import { Container, Grid, Typography } from '@mui/material';
import img0 from '../../utils/images/aboutUs.jfif';
import img1 from '../../utils/images/aboutUs1.JPG';
import img2 from '../../utils/images/aboutUs2.jfif';
import uwp3 from '../../utils/images/uwp-3.jpg';
import React from 'react';
import { Navbar } from '../../components/Navbar/Navbar';
import './About.css';
import { fontSize } from '@mui/system';
import Tickers from '../../components/Tickers/Tickers';
import Footer from '../../components/Footer/Footer';


const AboutUs = () => {
  return (
    <div>
      <Navbar />
      {/* <Tickers></Tickers> */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          height: '457px',
          paddingTop: '100px',
          background: `rgba(0, 0, 0,0.8) url(${img0})`,

          backgroundSize: 'cover',
          position: 'relative',
          backgroundPosition: 'center',
          zIndex: -1,
          flexDirection: 'column',
          backgroundBlendMode: 'darken',

          // marginTop: '20px',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: '#FFFFFF',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            marginTop: '50px',
            fontWeight: 'bold',
            fontSize: "3.2rem",

          }}
        >
          About Us
        </Typography>
        <Typography
          variant="h4"
          sx={{
            // fontFamily: "Sora",
            color: 'white',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            // fontWeight:"bold",
            // fontSize:["20px","30px","30px"],
            font: 'poppins',
            fontSize: '28px',
          }}
        >
          Know More About UWP
        </Typography>
      </div>
      <div style={{ display: 'flex', flexDirection: 'Column', marginTop: '100px' }}>
        <Typography
          variant="h5"
          sx={{
            display: 'flex',
            width: '100%',
            fontFamily: 'poppins',
            justifyContent: 'center',
            color: '#FF7345',
            fontWeight: 'bold',
            marginBottom: '20px',
          }}
        >
          University Wellness Program
        </Typography>
        {/* <Grid
          Container
          sx={{
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
            px: [0, 0, 5, 5, 5],
            marginTop: [4, 4, 5, 5, 4],
          }}
        >
          <Grid
            item
            md={4}
            sm={12}
            xs={12}
            sx={{
              width: ['100%', '60%', '100%', '100%', '100%'],
              display: 'flex',
              justifyContent: 'center',
              marginLeft: [0, 16, 0, 0, 0, 0],
            }}
          >
            <img
              style={{
                width: '100%',
                height: '100%',
              }}
              src={img1}
            />
          </Grid>
          <Grid item md={8} sm={12} xs={12}>
            <Typography
              sx={{
                fontFamily: 'poppins',
                px: [0, 4, 4, 5, 10],
                py: [4, 4, 4, 5, 5],
              }}
            >
              The University Wellness Program (UWP) is a university-wide program that aims to better the wellness of
              students, faculty and other stakeholders on campus. The program uses ‘Research + Action’ to address
              various aspects of one’s wellbeing. UWP looks at several aspects of one’s wellness and ways that we as a
              university can take steps to promote, improve and create awareness about students’ wellbeing. It focuses
              on enabling sustainable ways to achieve wellness for all university stakeholders and aims to leverage
              existing academic programs and coursework, for students to apply the concepts for research and action. In
              the first year of its inception, the students of SPH learnt Research Methodology (an existing module in
              the programs) to address the status of students’ overall wellbeing and mental wellbeing of university
              students and their coping mechanisms.
            </Typography>
          </Grid>
        </Grid>

        <div className="content-2">
          <p>
            In the first year of its inception, the students of SPH learnt Research Methodology (an existing module in
            the programs) to address the status of students’ overall wellbeing and mental wellbeing of university
            students and their coping mechanisms.
          </p>
        </div>
        <Grid
          Container
          sx={{
            display: 'flex',
            flexDirection: ['column', 'column', 'row-reverse'],
            px: [0, 0, 5, 5, 5],
            marginTop: [4, 4, 10, 10, 10],
          }}
        >
          <Grid
            item
            md={4}
            sm={12}
            xs={12}
            sx={{
              width: ['100%', '60%', '100%', '100%', '100%'],
              display: 'flex',
              justifyContent: 'center',
              marginLeft: [0, 16, 0, 0, 0, 0],
            }}
          >
            <img
              style={{
                width: '100%',
                height: '100%',
              }}
              src={img2}
            />
          </Grid>
          <Grid item md={8} sm={12} xs={12}>
            <Typography
              sx={{
                fontFamily: 'Sora',
                px: [0, 4, 4, 5, 10],
                py: [4, 4, 4, 5, 5],
              }}
            >
              Apart from having hands on experience with applying concepts of research, through this program, they have
              also had the opportunity to focus on a more action-oriented approach to wellness. As part of UWP, students
              have been carrying out monthly campaigns to create awareness about various different public health issues,
              primarily though social media. UWP hopes to create more impact through collaboration with different
              departments of SRMIST and address wellbeing on campus through more action driven solutions.The UWP Digital
              Platform is a way to bring all the work that UWP has done and will continue to do together.
            </Typography>
          </Grid>
        </Grid> */}
        <div className="container about">
          <div className="content-1 container">
            <img className="content-img" src={uwp3}></img>
            <div>
              <p>
                The University Wellness Program (UWP) is a university-wide program that aims to better the wellness of
                students, faculty and other stakeholders on campus. The program uses ‘Research + Action’ to address
                various aspects of one’s wellbeing. UWP looks at several aspects of one’s wellness and ways that we as a
                university can take steps to promote, improve and create awareness about students’ wellbeing. It focuses
                on enabling sustainable ways to achieve wellness for all university stakeholders and aims to leverage
                existing academic programs and coursework, for students to apply the concepts for research and action.
                In the first year of its inception, the students of SPH learnt Research Methodology (an existing module
                in the programs) to address the status of students’ overall wellbeing and mental wellbeing of university
                students and their coping mechanisms.
              </p>
            </div>
          </div>

          <div className='content-2 container'>
            <p>
              In the first year of its inception, the students of SPH learnt Research Methodology (an existing module in
              the programs) to address the status of students’ overall wellbeing and mental wellbeing of university
              students and their coping mechanisms.
            </p>
          </div>

          <div className="content-3 container">
            <img className="content-img" src={img2}></img>
            <div>
              <p>
                Apart from having hands on experience with applying concepts of research, through this program, they have
                also had the opportunity to focus on a more action-oriented approach to wellness. As part of UWP, students
                have been carrying out monthly campaigns to create awareness about various different public health issues,
                primarily though social media.
                <br></br>
                <br></br>

                UWP hopes to create more impact through collaboration with different
                departments of SRMIST and address wellbeing on campus through more action driven solutions.The UWP Digital
                Platform is a way to bring all the work that UWP has done and will continue to do together.
              </p>
            </div>
          </div>




        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <Footer></Footer>
    </div>
  );
};

export default AboutUs;
